const isLoadDone = () => document.readyState === 'complete'

const afterOnLoad = (fn, timeout) => {
  if (isLoadDone) {
    window.setTimeout(fn, timeout)
    return
  }

  window.addEventListener('load', () => {
    window.setTimeout(fn, timeout)
  })
}

export { afterOnLoad }
